import { Fragment, useState } from 'react';
import { Button, Dialog } from '@schibsted-svp/react-ui';

import { EndpointParamsList } from '../EndpointParamsList/EndpointParamsList';

import { EndpointParamsForm } from './EndpointParamsForm/EndpointParamsForm';

import type { DataType } from '../../../../types';

import styles from './EndpointParamsPicker.module.scss';

type EndpointParams = Record<string, unknown>;

type Props = {
  endpoint: string;
  dataType: DataType | string;
  params?: EndpointParams;
  onSubmit: (params: EndpointParams) => void;
};

function EndpointParamsPicker({
  endpoint,
  dataType,
  params = {},
  onSubmit,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  function onButtonClick() {
    setIsOpen(true);
  }

  function onDialogClose() {
    setIsOpen(false);
  }

  function onFormSubmit(submittedParams: EndpointParams) {
    setIsOpen(false);

    onSubmit(submittedParams);
  }

  const hasParams = Object.keys(params).length > 0;

  return (
    <Fragment>
      <div className={styles.container}>
        <EndpointParamsList params={params} />
        <Button
          type="button"
          variant="standard"
          size="small"
          onClick={onButtonClick}
        >
          {hasParams ? 'Change' : 'Set'} parameters
        </Button>
      </div>
      <Dialog
        isOpen={isOpen}
        onClose={onDialogClose}
        heading={`Set parameters for ${endpoint}`}
        className={styles.dialog}
      >
        <EndpointParamsForm
          dataType={dataType}
          endpoint={endpoint}
          params={params}
          onSubmit={onFormSubmit}
          onCancel={onDialogClose}
        />
      </Dialog>
    </Fragment>
  );
}

export { EndpointParamsPicker };
